import { useState, useEffect, useRef } from 'react';
import config from '../config';
import { Device } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

interface FilterCriteria {
  ean: string;
}

const useFetchDeviceByEan = (filterCriteria: FilterCriteria) => {
  const [deviceResponse, setDeviceResponse] = useState<Device>({
    id: 0,
    purchases: [],
    services: [],
    updatedAt: new Date(),
    createdAt: new Date(),
    lastApiCall: new Date(),
    dns: { id: 0, internalIP: '', ip: '' },
    ean: '',
    crmInfo: {
      isInCrm: false,
      product: { description: '', name: '', link: '' },
      customer: { address: '', zip: '', town: '', clientCode: '', link: '', name: '' },
      isShipped: false,
      shipment: { link: '', name: ''}
    }
  });
  const [error, setError] = useState<string | null>(null);
  const previousEanRef = useRef<string | null>(null);
    const { sessionState } = useSession();

  useEffect(() => {
    const fetchDeviceByEan = async () => {
      try {
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/device/ean/${filterCriteria.ean}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        console.log(data);
        setDeviceResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };
    if (filterCriteria.ean && filterCriteria.ean !== '' && filterCriteria.ean !== previousEanRef.current) {
      fetchDeviceByEan();
      previousEanRef.current = filterCriteria.ean; // Update the previous EAN ref
      setError('');
    } else if (!filterCriteria.ean || filterCriteria.ean === '') {
      setError('EAN cannot be empty');
    }
  }, [filterCriteria, sessionState]);

  return { deviceResponse, error };
};

export default useFetchDeviceByEan;
